import axios from 'axios';
import { baseURL, CRYPTO_SECRET_KEY, MIXPANEL_KEY } from '../constants/applicationConstants';
import mixpanel from "mixpanel-browser"
var CryptoJS = require("crypto-js");
mixpanel.init(MIXPANEL_KEY, { debug: true, });
export const encrypt = value => {
  const encrypted = CryptoJS.AES.encrypt(value, CRYPTO_SECRET_KEY);
  return encrypted.toString();
};

export const decrypt = value => {
  const decrypted = CryptoJS.AES.decrypt(value, CRYPTO_SECRET_KEY);
  const originalText = decrypted.toString(CryptoJS.enc.Utf8);
  return originalText;
};


export const isValidEmail = (email) => {
  const pattern =
    /^(([^<>().,;:\s@"]+(\.[^<>().,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(String(email));
};

export const isValidPhone = (mobile) => {
  let pattern = /^[1-9]{1}[0-9]{9}$/;
  return pattern.test(mobile);
};

export function formatAmount(amount = 0) {
  return "$" + Number.parseFloat(amount).toFixed(2);
}

export const convertFloatTwoDecimal = function (num) {
  if (!!num && num > 0) return parseFloat(num).toFixed(2);
  else return "0.00";
};


export const emailRegex =
  /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})$/;


export const postalCodeRegex = /^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/;

export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#()^@$!%*?&])[A-Za-z\d@$!#()^%*?&]{8,30}$/;

export const phoneRegex = /^[0-9]{10}$/;

// export const websiteRegex = /(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/
export const websiteRegex = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;

export const nameRegex = /^[A-Za-z\s]+$/;
export const cardRegex = /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;
export const monthRegex = /(0[1-9]|1[012])/;
export const yearRegex = /(?:(?:19|20)[0-9]{2})/;
export const cvcRegex = /^[0-9]{3}$/;


export const alphaNumericRegex = /^[A-Za-z0-9\s]+$/;
export const allRegex = /[^\n]+/;

export const alphabetWithSpaceRegex = /^[A-Za-z \s]+$/;

export const formatInputValue = (date) => {
  if (!date) return '';
  return `${date.day}/${date.month}/${date.year}`;
};

export const getProperDateMonth = (value) => {

  if (value < 10 && value.length !== 2) {
    return `0${value}`
  } else {
    return value
  }
}

export const onOfferClick = (data) => {
  if (data?.externalUrl) {
    window.open(getProperWebsite(data.externalUrl), '_blank');
  }
  if (data?.externalLink) {
    window.open(getProperWebsite(data.externalLink), '_blank');
  }
}

export const getRoute = (userType, screen) => {
  switch (screen) {
    case 'login':
      if (userType === 'institutional') return '/institutionalRegistration'
      if (userType === 'expert') return '/expertRegistration'
      if (userType === 'customer') return '/customerRegistration'
      break;
    case 'otpGeneration': return '/passwordAuth'

    case 'institutionalRegistration':
      if (userType === 'institutional') return '/passwordAuth'
      else if (userType === 'unVerified') return '/admin/manageUnverifiedInstitute'
      else return '/plans'

    case 'customerRegistration':
      if (userType === 'customer') return '/passwordAuth'
      else if (userType === 'unVerified') return '/admin/manageUnverifiedInstitute'
      else return '/plans'

    case 'description':
      if (userType === 'admin') return '/expertPlans'
      else if (userType === 'unVerified') return '/admin/manageUnverifiedExpert'
      else return '/passwordAuth'

    case 'expertRegistration': return '/specialInformations'

    case 'passwordAuth': return '/newPassword'
    case 'passwordAuth1': return '/specialInformations'


    case 'newPassword':
      if (userType === 'institutional') return '/plans'
      if (userType === 'expert') return '/expertPlans'
      else return '/passwordSuccess'

    case 'plans': return '/plansSummary'

    case 'plansSummary': return '/addCard'

    case 'onboarding-pwd':
      if (userType === 'Institutional') return '/Inst-plan-Dashboard'
      else return '/expert-plan-Dashboard'

    case 'onbording-pay':
      if (userType === 'Institutional') return '/Inst-success-Dashboard'
      else return '/expert-success-Dashboard'

    default: return '/'
  }
}

export const getProperWebsite = (website) => {
  if (!website?.includes('http'))
    return `https://${website}`
  else return website
}

export const formatCanadianPhoneNumber = (number) => {
  // Remove any non-numeric characters
  const cleanedNumber = String(number).replace(/\D/g, '');

  // Divide the number into area code, exchange, and subscriber parts
  const areaCode = cleanedNumber.substring(0, 3);
  const exchange = cleanedNumber.substring(3, 6);
  const subscriber = cleanedNumber.substring(6);

  // Format the number
  return `(${areaCode}) ${exchange}-${subscriber}`;
}

export const fetchArticleDataFromAPI = async (categoryName, type, page, search, limit) => {
  // var data = new FormData();
  // data.append('device_token', '20.204.66.244');
  // data.append('cat_slug', categoryName);
  // data.append('paged', page)
  // data.append('type', type)
  // data.append('search', search)
  // limit && data.append('limit', limit);
  let token = JSON.parse(sessionStorage.getItem('token'));
  const response = await axios.get(`${baseURL}/articles?search=${search}&categorySlug=${categoryName}&type=${type}&page=${page}&limit=${limit}`, {
    headers: { 'x-access-token': token }
  });
  return response;
}

export const ModulePermission = () => {
  const roleControl = JSON.parse(sessionStorage.getItem("roleManager"));

  const canCreateExpert = roleControl?.ManageExperts?.includes("expert.create");
  const canReadExpert = roleControl?.ManageExperts?.includes("expert.read");
  const canDeleteExpert = roleControl?.ManageExperts?.includes("expert.delete");

  const canCreateInstitute = roleControl?.ManageInstitutions?.includes("institute.create");
  const canReadInstitute = roleControl?.ManageInstitutions?.includes("institute.read");
  const canDeleteInstitute = roleControl?.ManageInstitutions?.includes("institute.delete");

  const canAssignQuestionCreate = roleControl?.ManageQuestions?.includes("assignquestion.create");
  const canAssignQuestionRead = roleControl?.ManageQuestions?.includes("assignquestion.read");
  const canAssignQuestionDelete = roleControl?.ManageQuestions?.includes("assignquestion.delete");

  const canManageUnverifiedExpertsCreate = roleControl?.ManageUnverifiedExperts?.includes("unverified-expert.create");
  const canManageUnverifiedExpertsRead = roleControl?.ManageUnverifiedExperts?.includes("unverified-expert.read");
  const canManageUnverifiedExpertsDelete = roleControl?.ManageUnverifiedExperts?.includes("unverified-expert.delete");

  const canManageUnverifiedInstitutesCreate = roleControl?.ManageUnverifiedInstitutes?.includes("unverified-institutes.create");
  const canManageUnverifiedInstitutesRead = roleControl?.ManageUnverifiedInstitutes?.includes("unverified-institutes.read");
  const canManageUnverifiedInstitutesDelete = roleControl?.ManageUnverifiedInstitutes?.includes("unverified-institutes.delete");

  const canCreateOffer = roleControl?.ManageOffers?.includes("offers.create");
  const canReadOffer = roleControl?.ManageOffers?.includes("offers.read");
  const canDeleteOffer = roleControl?.ManageOffers?.includes("offers.delete");

  const canReadPayment = roleControl?.TrackPayment?.includes("track-payment.read");
  const canCreatePayment = roleControl?.TrackPayment?.includes("track-payment.create");

  const canCreateProduct = roleControl?.ManageProducts?.includes("products.create");
  const canReadProduct = roleControl?.ManageProducts?.includes("products.read");
  const canDeleteProduct = roleControl?.ManageProducts?.includes("products.delete");

  const canCreateAd = roleControl?.ManageAdvertisements?.includes("ads.create");
  const canReadAd = roleControl?.ManageAdvertisements?.includes("ads.read");
  const canDeleteAd = roleControl?.ManageAdvertisements?.includes("ads.delete");

  const canCreateCategory = roleControl?.CategoryManagement?.includes("manage-category.create");
  const canReadCategory = roleControl?.CategoryManagement?.includes("manage-category.read");
  const canDeleteCategory = roleControl?.CategoryManagement?.includes("manage-category.delete");

  const canReadModule = roleControl?.ModulesManagement?.includes("manage-module.read");
  const canCreateModule = roleControl?.ModulesManagement?.includes("manage-module.create");
  const canDeleteModule = roleControl?.ModulesManagement?.includes("manage-module.delete");

  const canManageQuestionCreate = roleControl?.QuestionManagement?.includes("manage-question.create");
  const canManageQuestionRead = roleControl?.QuestionManagement?.includes("manage-question.read");
  const canManageQuestionDelete = roleControl?.QuestionManagement?.includes("manage-question.delete");

  const canManagePlanCreate = roleControl?.PlanManagement?.includes("manage-plan.create");
  const canManagePlanRead = roleControl?.PlanManagement?.includes("manage-plan.read");
  const canManagePlanDelete = roleControl?.PlanManagement?.includes("manage-plan.delete");

  const canManageQueryRead = roleControl?.QueryManagement?.includes("help-support.read");

  return {
    canCreateExpert, canReadExpert, canDeleteExpert,
    canCreateInstitute, canReadInstitute, canDeleteInstitute,
    canAssignQuestionCreate, canAssignQuestionRead, canAssignQuestionDelete,
    canManageUnverifiedExpertsCreate, canManageUnverifiedExpertsRead, canManageUnverifiedExpertsDelete,
    canManageUnverifiedInstitutesCreate, canManageUnverifiedInstitutesRead, canManageUnverifiedInstitutesDelete,
    canCreateOffer, canReadOffer, canDeleteOffer,
    canReadPayment, canCreatePayment,
    canCreateProduct, canReadProduct, canDeleteProduct,
    canCreateAd, canReadAd, canDeleteAd,
    canCreateCategory, canReadCategory, canDeleteCategory,
    canReadModule, canCreateModule, canDeleteModule,
    canManageQuestionCreate, canManageQuestionRead, canManageQuestionDelete,
    canManagePlanCreate, canManagePlanRead, canManagePlanDelete,
    canManageQueryRead

  };
};



export const decodeHtmlEntities = (text) => {
  if (typeof text !== 'string') {
    return text;
  }
  const parser = new DOMParser();
  const decodedString = parser.parseFromString(text, 'text/html').body.textContent;
  return decodedString;
};

export const fetchIdFromName = async (name) => {
  // Get the token from sessionStorage
  let token = JSON.parse(sessionStorage.getItem('token'));

  // First, check if the data is available in sessionStorage
  let dataFromSession = JSON.parse(sessionStorage.getItem('institutionCategoriesAndSubCategories'));

  if (dataFromSession) {
    // If data is found in sessionStorage, use it directly
    const id = findCategoryIdByName(dataFromSession, name);
    return id;
  } else {
    // If no data is in sessionStorage, call the API
    try {
      const response = await axios.get(`${baseURL}/institutionCategoriesAndSubCategories`, {
        headers: { 'x-access-token': token }
      });

      // Store the response data in sessionStorage
      sessionStorage.setItem('institutionCategoriesAndSubCategories', JSON.stringify(response.data.data));

      // Return the category ID using the data received from API
      const id = findCategoryIdByName(response.data.data, name);
      return id;
    } catch (err) {
      return err;  // In case of error, return the error
    }
  }
};

export const mixPannelEvent = (mixpanelData) => {
  mixpanel.track("aaaaa",
    mixpanelData.data
  )
}

// Helper function to find category ID by name
const findCategoryIdByName = (data, categoryName) => {
  const normalize = (name) => name.replace(/\s+/g, '').toLowerCase();  // Normalize the name by removing spaces and converting to lowercase

  // Loop through the categories to find a match by name
  for (const category of data) {
    if (normalize(category.name) === normalize(categoryName)) {
      return category.institutionCategoryId;
    }

    // Search in subcategories if no match is found in categories
    for (const subCategory of category.subInstitutionCategories || []) {
      if (subCategory.name.toLowerCase() === categoryName.toLowerCase()) {
        return subCategory.institutionCategoryId;
      }
    }
  }

  return null; // If no match is found
};


export function convertToCanadianDateTime(dateTimeString) {
  try {
    // const date = new Date(dateTimeString);

    // if (isNaN(date.getTime())) {
    //   return "Invalid Date/Time format";
    // }

    // const optionsDateTime = {
    //   year: 'numeric',
    //   month: 'numeric',
    //   day: 'numeric',
    //   hour: 'numeric',
    //   minute: 'numeric',
    //   second: 'numeric',
    //   hour12: false, // Use 24-hour format for time
    //   timeZone: 'America/Toronto' // Canadian Eastern Time Zone
    // };

    // const optionsDateOnly = {
    //   year: 'numeric',
    //   month: 'numeric',
    //   day: 'numeric',
    //   timeZone: 'America/Toronto' // Canadian Eastern Time Zone
    // };

    // // Check if the input string seems to have a time component
    // if (dateTimeString.includes('T')) {
    //   return new Intl.DateTimeFormat('en-CA', optionsDateTime).format(date);
    // } else {
    //   return new Intl.DateTimeFormat('en-CA', optionsDateOnly).format(date);
    // }

    const date = new Date(dateTimeString);

    // Check if the date parsing was successful.
    // Invalid date strings will result in a Date object where getTime() is NaN.
    if (isNaN(date.getTime())) {
      return "Invalid Date String";
    }

    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' }); // e.g., "Jun" for June
    const year = date.getFullYear();

    let daySuffix;
    if (day >= 11 && day <= 13) {
      daySuffix = 'th'; // Special case for 11th, 12th, 13th
    } else {
      switch (day % 10) {
        case 1:
          daySuffix = 'st';
          break;
        case 2:
          daySuffix = 'nd';
          break;
        case 3:
          daySuffix = 'rd';
          break;
        default:
          daySuffix = 'th';
          break;
      }
    }

    return `${day}${daySuffix} ${month} ${year}`;

  } catch (error) {
    console.error("Error parsing date/time string:", error);
    return "Invalid Date/Time format";
  }
}


export const categoryEnum = {
  'realEstate': 'real-estate',
  'investment': 'investment',
  'mortgage': 'mortgage',
  'insurance': 'insurance',
  'banking': 'banking',
}

export  function decodeIfEncoded(str) {
  try {    
    const decodedStr = decodeURIComponent(str);

    if (decodedStr !== str && /%[0-9a-fA-F]{2}/.test(str)) {
      return decodedStr;
    } else {
      
      return str;
    }
  } catch (e) {
    // decodeURIComponent can throw a URIError if the encoding is invalid
    // (e.g., "%G2" - not a valid hex pair).
    // If an error occurs, it means the string was either malformed or not
    // intended to be URL-encoded, so return the original.
    console.warn("Error during decoding, returning original string:", e);
    return str;
  }
}